import { Box } from '@mui/material';

// <Avatar
//   sx={{
//     backgroundColor:
//       option.surface_mode === 'Polished' ? '#ccc' : '#555',
//   }}
//   sizes="extra-small"
// >
//   {option.core_int_diff ? 'A' : 'S'}
// </Avatar>
export function BallTypeIcon({
  asymetrical = false,
  polished = false,
  size = 24,
}) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: '2px solid currentColor',
        borderStyle: polished ? 'solid' : 'dashed',
        position: 'relative',
        display: 'inline-block',
      }}
    >
      <Box
        sx={{
          width: size * 0.35,
          height: size * 0.35,
          borderRadius: '50%',
          backgroundColor: 'currentColor',
          position: 'absolute',
          top: '50%',
          left: asymetrical ? '65%' : '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </Box>
  );
}
